import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

export const studentExamRecording = createAsyncThunk('studentExamRecording', async ({ examId, studentId, navigate }) => {
    try {
        const query = new URLSearchParams({ examId: String(examId) })
        if (studentId != null && String(studentId).trim() !== '') query.set('student_id', String(studentId))
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `student_exam_recording?${query.toString()}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const studentExamRecordingSlice = createSlice({
    name: 'studentExamRecording',
    initialState: { data: null },
    extraReducers: (builder) => {
        builder.addCase(studentExamRecording.fulfilled, (state, action) => {
            if (action?.payload?.status === 200 && action?.payload?.data?.success !== false) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
    }
})

export default studentExamRecordingSlice.reducer;
